<template>
    <div v-if="status == 'successShop'">
        <form @submit.prevent="updateSettings" id="settings_form">
            <div id="message_div"></div>
            <kt-row>
                <kt-col lg="5" md="4" sm="12">
                    <div class="container p-3 pt-5 my-4 border in-border-header">
                        <div class="section-header">
                            {{ $t('label.using_switch') }}
                        </div>
                        <kt-row id="first_row">
                            <kt-form-group>
                                <div style="padding-right: 35px" class="custom-control custom-switch"
                                     id="switching_status-div">
                                    <input
                                            type="checkbox"
                                            class="custom-control-input"
                                            id="switching_status"
                                            name="switching_status"
                                            @change="changeLabel"
                                            v-model="gateway.switching_status"
                                    >
                                    <label class="custom-control-label" id="switching_status_label"
                                           for="switching_status"></label>
                                </div>
                            </kt-form-group>
                            <kt-form-group>
                                <div style="padding-right: 35px" class="custom-control custom-switch"
                                     id="allow_user_switching-div">
                                    <input
                                            type="checkbox"
                                            class="custom-control-input"
                                            id="allow_user_switching"
                                            name="allow_user_switching"
                                            @change="changeLabel"
                                            v-model="gateway.allow_user_switching"
                                    >
                                    <label class="custom-control-label" for="allow_user_switching">
                                        {{ $t('label.allow_user_switching') }}
                                    </label>
                                </div>
                            </kt-form-group>
                        </kt-row>
                        <kt-row v-if="!gateway.switching_status">
                            <kt-col lg="12" md="12" sm="12" v-for="(psp, index) in active_psp_list" :key="index" class="mb-5">
                                <kt-form-label :for="'priority_' + (index + 1)">
                                    {{ $t('label.priority') + (index + 1) }}
                                </kt-form-label>
                                <kt-form-select
                                        v-model="gateway.terminal_priorities[(index + 1)]"
                                        class="form-control"
                                        :name="'priority_' + (index + 1)"
                                        :id="'priority_' + (index + 1)"
                                >
                                    <option name="psp_name" v-for="(psp_name, index) in active_psp_list"
                                            :key="index"
                                            :value="psp_name"
                                            :selected="gateway.terminal_priorities[(index + 1)] == psp_name"
                                    >
                                        {{ $t('psp.' + psp_name) }}
                                    </option>
                                </kt-form-select>
                            </kt-col>
                        </kt-row>
                    </div>
                </kt-col>
                <kt-col lg="7" md="8" sm="12">
                    <div class="container p-3 pt-5 my-4 border in-border-header">
                        <div class="section-header">
                            {{ $t('label.collective_status') }}
                        </div>
                        <kt-row id="first_row" style="padding-right: 10px">
                            <kt-form-group>
                                <div class="custom-control custom-switch" id="collective_status-div">
                                    <input
                                            type="checkbox"
                                            class="custom-control-input"
                                            id="collective_status"
                                            name="collective_status"
                                            @change="changeLabel"
                                            :disabled="is_dedicated"
                                            v-model="form_data.status"
                                    >
                                    <label class="custom-control-label" id="collective_status_label"
                                           for="collective_status"></label>
                                </div>
                            </kt-form-group>
                        </kt-row>
                        <kt-row v-if="form_data.status">
                            <kt-col lg="6" md="6" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="priority">
                                        {{ $t('label.priority') }}
                                    </kt-form-label>
                                    <select
                                            id="priority"
                                            name="priority"
                                            v-model="form_data.priority"
                                            class="form-control"
                                            @change="changeLabel"
                                    >
                                        <option value="1" :selected="form_data.priority == 1">
                                            {{ $t('label.normal_priority') }}
                                        </option>
                                        <option value="2" :selected="form_data.priority == 2">
                                            {{ $t('label.high_priority') }}
                                        </option>
                                    </select>
                                </kt-form-group>
                            </kt-col>
                            <kt-col v-show="form_data.transaction_type == 0" lg="6" md="6" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="collective">
                                        {{ $t('label.dedicated_shop_categories') }}
                                    </kt-form-label>
                                    <kt-form-select
                                            class="form-control"
                                            v-model="form_data.category_id"
                                    >
                                        <option
                                            :value="null"
                                            :selected="!form_data.category_id"
                                        >
                                            {{ 'هیچکدام' }}
                                        </option>
                                        <option
                                            v-for="category in dedicated_categories"
                                            :key="category.id"
                                            :value="category.id"
                                            :selected="category.id === form_data.category_id"
                                            >
                                            {{ category.title }}
                                        </option>
                                    </kt-form-select>
                                </kt-form-group>
                            </kt-col>
                        </kt-row>
                        <kt-row v-if="form_data.status">
                            <kt-col lg="6" md="6" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="transaction_type">
                                        {{ $t('label.transaction_type') }}
                                    </kt-form-label>
                                    <kt-form-select
                                            v-model="form_data.transaction_type"
                                            class="form-control"
                                            name="transaction_type"
                                            @change="changeLabel"
                                    >
                                        <option name="shop_id"
                                                value="0"
                                                :selected="gateway.shop_id == form_data.shop_id"
                                        >
                                            {{ $t('btn.buy') }}
                                        </option>
                                        <option name="shop_id"
                                                value="1"
                                                :selected="gateway.shop_id == form_data.shop_id"
                                        >
                                            {{ $t('bill-service.bill_transaction') }}
                                        </option>
                                    </kt-form-select>
                                </kt-form-group>
                            </kt-col>
                            <!--                            <kt-col lg="6" md="6" xs="12">-->
                            <!--                                <kt-form-group>-->
                            <!--                                    <div class="custom-control custom-switch" id="transaction_type-div">-->
                            <!--                                        <input-->
                            <!--                                                type="checkbox"-->
                            <!--                                                class="custom-control-input"-->
                            <!--                                                id="transaction_type"-->
                            <!--                                                name="transaction_type"-->
                            <!--                                                v-model="form_data.transaction_type"-->
                            <!--                                        >-->
                            <!--                                        <label v-if="!form_data.transaction_type" class="custom-control-label"-->
                            <!--                                               id="transaction_type_label" for="transaction_type">-->
                            <!--                                            {{ $t('btn.buy') }}-->
                            <!--                                        </label>-->
                            <!--                                        <label v-if="form_data.transaction_type" class="custom-control-label"-->
                            <!--                                               id="transaction_type_label" for="transaction_type">-->
                            <!--                                            {{ $t('bill-service.bill_transaction') }}-->
                            <!--                                        </label>-->
                            <!--                                    </div>-->
                            <!--                                </kt-form-group>-->
                            <!--                            </kt-col>-->
                            <kt-col v-if="form_data.transaction_type == 1" lg="6" md="6" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="bill_psp">
                                        {{ $t('label.psp') }}
                                    </kt-form-label>
                                    <kt-form-select
                                            id="bill_psp"
                                            name="bill_psp"
                                            @change="setBillSettings"
                                            v-model="form_data.bill_psp"
                                            class="form-control"
                                    >
                                        <option value="" :selected="form_data.bill_psp == ''">
                                            {{ $t('selectpicker.nothing_selected') }}
                                        </option>
                                        <option
                                                v-bind:key="index"
                                                v-for="(psp, index) in activeBillPsp"
                                                v-bind:value="psp.value"
                                                :selected="psp.value == form_data.bill_psp"
                                        >
                                            {{ psp.title }}
                                        </option>
                                    </kt-form-select>
                                </kt-form-group>
                            </kt-col>
                            <kt-col v-if="form_data.transaction_type == 1 && form_data.bill_psp" lg="6" md="6" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="bill_shop">
                                        {{ $t('label.chose_gateway') }}
                                    </kt-form-label>
                                    <select
                                            id="bill_shop"
                                            name="bill_shop"
                                            v-model="form_data.bill_shop"
                                            class="form-control"
                                    >
                                        <option value="" :selected="form_data.bill_shop == ''">
                                            {{ $t('selectpicker.nothing_selected') }}
                                        </option>
                                        <option
                                                v-for="terminal in bill_data.psp_shops"
                                                v-bind:value="terminal.id"
                                                v-bind:key="terminal.id"
                                                :selected="terminal.id == form_data.bill_shop"
                                        >
                                            {{ terminal.name }}
                                        </option>
                                    </select>
                                </kt-form-group>
                            </kt-col>
<!--                            <kt-col lg="6" md="6" xs="12" v-if="form_data.transaction_type == 1-->
<!--                                 && form_data.bill_psp == pspList.MELLAT">-->
<!--                                <kt-form-group>-->
<!--                                    <kt-form-label for="transaction_count_limit">-->
<!--                                        {{ $t('bill-service.mellat_bill_code') }}-->
<!--                                    </kt-form-label>-->
<!--                                    <kt-form-control-->
<!--                                            dir="ltr"-->
<!--                                            id="mellat_bill_code"-->
<!--                                            type="number"-->
<!--                                            name="mellat_bill_code"-->
<!--                                            v-model="form_data.mellat_bill_code">-->
<!--                                    </kt-form-control>-->
<!--                                </kt-form-group>-->
<!--                            </kt-col>-->
                            <kt-col v-if="form_data.transaction_type == 1 && form_data.bill_psp" lg="6" md="6" xs="12">
                                <kt-form-group>
                                    <kt-form-label v-show="form_data.bill_psp == pspList.PASARGAD" for="corporate">
                                        {{ $t('label.chose_corporate') }}
                                    </kt-form-label>
                                    <kt-form-label v-show="form_data.bill_psp == pspList.MELLAT" for="corporate">
                                        {{ $t('bill-service.chose_mellat_bill_code') }}
                                    </kt-form-label>
                                    <select
                                            id="corporate"
                                            name="corporate"
                                            v-model="form_data.corporate"
                                            class="form-control"
                                    >
                                        <option value="" :selected="form_data.corporate == ''">
                                            {{ $t('selectpicker.nothing_selected') }}
                                        </option>
                                        <option
                                                v-for="corporate in bill_data.psp_corporates"
                                                v-bind:value="corporate.id"
                                                v-bind:key="corporate.id"
                                                :selected="corporate.id == form_data.corporate"
                                        >
                                            {{ corporate.business_name }}
                                        </option>
                                    </select>
                                </kt-form-group>
                            </kt-col>

                        </kt-row>
                        <kt-row v-if="form_data.status">
                            <kt-col lg="4" md="4" xs="12">
                                <kt-form-group>
                                    <div class="custom-control custom-switch" id="has_time_limitation-div">
                                        <input
                                                type="checkbox"
                                                class="custom-control-input"
                                                id="has_time_limitation"
                                                name="has_time_limitation"
                                                v-model="form_data.has_time_limitation"
                                        >
                                        <label class="custom-control-label" id="has_time_limitation_label"
                                               for="has_time_limitation">
                                            {{ $t('label.has_time_limitation') }}
                                        </label>
                                    </div>
                                </kt-form-group>
                            </kt-col>
                            <kt-col lg="4" md="4" xs="12" v-if="form_data.has_time_limitation">
                                <kt-form-group>
                                    <kt-form-label for="start_date">
                                        {{ $t('label.start_date') }}
                                    </kt-form-label>
                                    <datePicker
                                            format="YYYY-MM-DD"
                                            display-format="jDD jMMMM jYYYY"
                                            input-class="form-control"
                                            id="start_date"
                                            name="start_date"
                                            type="datetime"
                                            v-model="form_data.start_date"
                                    />
                                </kt-form-group>
                            </kt-col>
                            <kt-col lg="4" md="4" xs="12" v-if="form_data.has_time_limitation">
                                <kt-form-group>
                                    <kt-form-label for="end_date">
                                        {{ $t('label.end_date') }}
                                    </kt-form-label>
                                    <datePicker
                                            format="YYYY-MM-DD"
                                            display-format="jDD jMMMM jYYYY"
                                            input-class="form-control"
                                            id="end_date"
                                            name="end_date"
                                            type="datetime"
                                            v-model="form_data.end_date"
                                    />
                                </kt-form-group>
                            </kt-col>
                        </kt-row>
                        <kt-row v-if="form_data.status">
                            <kt-col lg="6" md="6" xs="6">
                                <kt-form-group>
                                    <div class="custom-control custom-switch" id="has_transaction_count_limitation-div">
                                        <input
                                                type="checkbox"
                                                class="custom-control-input"
                                                id="has_transaction_count_limitation"
                                                name="has_transaction_count_limitation"
                                                v-model="form_data.has_transaction_count_limitation"
                                        >
                                        <label class="custom-control-label" id="has_count_limitation_label"
                                               for="has_transaction_count_limitation">
                                            {{ $t('label.has_transaction_count_limitation') }}
                                        </label>
                                    </div>
                                </kt-form-group>
                            </kt-col>
                            <kt-col lg="6" md="6" xs="6" v-if="form_data.has_transaction_count_limitation">
                                <kt-form-group>
                                    <kt-form-label for="transaction_count_limit">
                                        {{ $t('label.count_limit') }}
                                    </kt-form-label>
                                    <kt-form-control
                                            dir="ltr"
                                            id="transaction_count_limit"
                                            type="number"
                                            name="transaction_count_limit"
                                            v-model="form_data.transaction_count_limit">
                                    </kt-form-control>
                                </kt-form-group>
                            </kt-col>
                        </kt-row>
                        <kt-row v-if="form_data.status">
                            <kt-col lg="6" md="6" xs="12">
                                <kt-form-group>
                                    <div class="custom-control custom-switch"
                                         id="has_transaction_amount_limitation-div">
                                        <input
                                                type="checkbox"
                                                class="custom-control-input"
                                                id="has_transaction_amount_limitation"
                                                name="has_transaction_amount_limitation"
                                                v-model="form_data.has_transaction_amount_limitation"
                                        >
                                        <label class="custom-control-label" id="has_amount_limitation_label"
                                               for="has_transaction_amount_limitation">
                                            {{ $t('label.has_transaction_amount_limitation') }}
                                        </label>
                                    </div>
                                </kt-form-group>
                            </kt-col>
                            <kt-col lg="6" md="6" xs="12" v-if="form_data.has_transaction_amount_limitation">
                                <kt-form-group>
                                    <kt-form-label for="transaction_amount_limit">
                                        {{ $t('label.amount_limit') }}
                                    </kt-form-label>
                                    <div class="kt-input-icon kt-input-icon--right">
                                        <kt-form-control
                                                dir="ltr"
                                                id="transaction_amount_limit"
                                                name="transaction_amount_limit"
                                                v-model="form_data.transaction_amount_limit">
                                        </kt-form-control>
                                        <span class="kt-input-icon__icon kt-input-icon__icon--right">
                                            <span>{{ $t('currency.rial') }}</span>
                                        </span>
                                    </div>
                                </kt-form-group>
                            </kt-col>
                        </kt-row>
                        <kt-row v-if="form_data.status">
                            <kt-col lg="6" md="6" xs="12">
                                <kt-form-group>
                                    <div class="custom-control custom-switch"
                                    id="skip_wallet_charge-div">
                                    <input
                                            type="checkbox"
                                            class="custom-control-input"
                                            id="skip_wallet_charge"
                                            name="skip_wallet_charge"
                                            @change="changeLabel"
                                            v-model="gateway.skip_wallet_charge"
                                    >
                                    <label class="custom-control-label" id="skip_wallet_charge_label"
                                            for="skip_wallet_charge">
                                            {{ $t('label.skip_wallet_charge') }}
                                    </label>
                                </div>
                                </kt-form-group>
                            </kt-col>
                        </kt-row>
                        <kt-row v-if="form_data.status">
                            <kt-col lg="6" md="6" xs="12">
                                <kt-form-group>
                                    <div class="custom-control custom-switch"
                                    id="skip_switching_setting-div">
                                    <input
                                            type="checkbox"
                                            class="custom-control-input"
                                            id="skip_switching_setting"
                                            name="skip_switching_setting"
                                            @change="changeLabel"
                                            v-model="gateway.skip_switching_setting"
                                    >
                                    <label class="custom-control-label" id="skip_switching_setting_label"
                                            for="skip_switching_setting">
                                            {{ $t('label.skip_switching_setting') }}
                                    </label>
                                </div>
                                </kt-form-group>
                            </kt-col>
                        </kt-row>
                    </div>
                </kt-col>
            </kt-row>
            <kt-row>
                <p>
                    {{ $t('label.switching_description_part_1') }}
                    <span :class="'badge ' + collective_status_variant">{{ selected_gateway }}</span>
                    {{ $t('label.switching_description_part_2') }}
                    <span :class="'badge ' + switching_status_variant">{{ switching_status }}</span>
                    {{ $t('label.switching_description_part_3') }}
                </p>
            </kt-row>
            <kt-form-action class="mt-4">
                <button class="btn btn-md btn-success btn-wide" type="submit" id="change_settings_btn">
                    {{ $t('btn.edit') }}
                </button>
            </kt-form-action>
        </form>
    </div>
</template>

<script>
import $ from "jquery"
import {i18n} from '@/plugins/i18n'
import {mapGetters} from "vuex"
import {KTApp} from '@/plugins/core/app'
import {collectiveService, dedicatedService} from '@/common/api.service'
import {pspList,activeBillPsp} from '@/constants/psp'

export default {
    props: {
        shop_type: {
            required: true
        },
        is_dedicated : {
            required: false
        }
    },
    data() {
        return {
            psp_list: [],
            active_psp_list: [],
            bill_settings: {},
            bill_data: {},
            pspList,
            activeBillPsp,
            selected_gateway: null,
            switching_status: null,
            switching_status_variant: null,
            collective_status_variant: null,
            dedicated_categories: [],
            is_starshop: this.$route.params.gateway_source === 'starshop-gateways',
        }
    },
    methods: {
        changeLabel() {
            let label = $('#collective_status_label')
            let checkbox = $('#collective_status')

            if (checkbox.is(':checked')) {
                if (this.form_data.priority == 2) {
                    this.selected_gateway = i18n.t('label.collective')
                    this.collective_status_variant = 'badge-warning'
                } else {
                    this.selected_gateway = i18n.t('label.pf')
                    this.collective_status_variant = 'badge-success'
                }
                label.html(i18n.t('label.active'))
            } else {
                this.selected_gateway = i18n.t('label.pf')
                this.collective_status_variant = 'badge-success'
                label.html(i18n.t('label.inactive'))
            }

            let switching_label = $('#switching_status_label')
            let switching_checkbox = $('#switching_status')
            if (switching_checkbox.is(':checked')) {
                this.switching_status = i18n.t('label.intelligent_switching_setting')
                this.switching_status_variant = 'badge-info'
                switching_label.html(i18n.t('label.active'))
            } else {
                if (this.form_data.shop_id || !checkbox.is(':checked')) {
                    this.switching_status = i18n.t('label.admin_selected_setting')
                    this.switching_status_variant = 'badge-success'
                } else {
                    this.switching_status = i18n.t('label.general_collective_setting')
                    this.switching_status_variant = 'badge-warning'
                }
                switching_label.html(i18n.t('label.inactive'))
            }

        },
        updateSettings() {
            let btn = $('#change_settings_btn')
            let form = $('#message_div')
            KTApp.progress(btn)

            let terminals = {};
            let gateway_terminals = this.gateway.shaparak_acceptors_status
            let i = 0;
            Object.values(this.gateway.terminal_priorities).forEach(function (psp) {
                i++;
                if (gateway_terminals[psp]) {
                    terminals[i]= psp
                }
            });

            delete this.form_data.shop_id;
            let params = {
                collective_settings: {
                    ...this.form_data,
                    skip_wallet_charge: this.gateway.skip_wallet_charge,
                    skip_switching_setting: this.gateway.skip_switching_setting
                },
                switching_settings: {
                    switching_status: this.gateway.switching_status,
                    terminal_priorities: terminals,
                    allow_user_switching: this.gateway.allow_user_switching,
                },
            }
            collectiveService.updateSwitchingSetting(this.form_data.gateway.id, params, this.is_starshop).then(response => {
                this.$store.dispatch('badgeCounter/countData', this.is_starshop)
                this.showMsg(form, 'success', i18n.t('message.edit_success'))
            }).catch(({response}) => {
                let message = document.createElement('div')
                message.innerHTML = response.data.message
                Object.keys(response.data.data).forEach(function (item) {
                    var li = document.createElement('li')
                    li.innerText = response.data.data[item][0]
                    message.insertAdjacentElement('beforeend', li)
                })
                this.showMsg(form, 'danger', message)
            }).finally(response => {
                KTApp.unprogress(btn)
            })
        },
        setPspList() {
            let psp_list = this.psp_list
            let gateway_terminals = this.gateway.terminals
            Object.keys(this.gateway.terminals).forEach(function (psp) {
                if (gateway_terminals[psp]) {
                    psp_list.push(psp)
                }
            });
            this.psp_list = psp_list
        },
        setActivePspList() {
            let active_psp_list = this.active_psp_list
            let gateway_terminals = this.gateway.shaparak_acceptors_status
            Object.keys(this.gateway.shaparak_acceptors_status).forEach(function (psp) {
                if (gateway_terminals[psp]) {
                    active_psp_list.push(psp)
                }
            });
            this.active_psp_list = active_psp_list
        },
        setBillSettings(is_first_try) {
            if (!is_first_try) {
                this.form_data.bill_shop = null
                this.form_data.corporate = null
            }
            let psp = this.form_data.bill_psp
            this.bill_data.psp_corporates = []
            this.bill_data.psp_shops = []
            for (let i = 0; i < this.active_collective_gateways.length; i++) {
                if (this.active_collective_gateways[i]['psp'] == psp) {
                    this.bill_data.psp_shops.push(this.active_collective_gateways[i])
                }
            }
            for (let i = 0; i < this.corporates.length; i++) {
                if (this.corporates[i]['psp'] == psp) {
                    this.bill_data.psp_corporates.push(this.corporates[i])
                }
            }
        },
        getCategoriesForSelect(){
          dedicatedService.fetchCategoriesForSelect(this.is_starshop)
              .then((response) => {
                  this.dedicated_categories = response.data.data;
              })
              .catch(({response})=>{

              }).finally(()=>{

          })
        },
    },

    computed: {
        ...mapGetters('collective', [
            'form_data',
            'status',
            'gateways'
        ]),
        ...mapGetters('bill', [
            'corporates','active_collective_gateways'
        ]),
        ...mapGetters('gateway', {
            gateway: 'form_data'
        }),
    },
    mounted() {
        this.$store.dispatch('bill/getCorporates').finally(()=> {
            this.$store.dispatch('bill/getActiveCollectiveGateways')
        })
        let query = {
            'query[gateway_status]': 1,
        }

      const is_starshop = this.$route.params.gateway_source === 'starshop-gateways';

        this.$store.dispatch('collective/fetch', query)
                .finally(() => {
                    if (this.shop_type == '-1') {
                        this.$store.dispatch('collective/find', this.$route.params.hashid)
                                .finally(() => {
                                    this.changeLabel()
                                })
                    } else {
                        let params = {
                            hashid: this.$route.params.hashid,
                            shop_type: this.shop_type
                        }
                        this.$store.dispatch('collective/findByShopId', {params: params, is_starshop: is_starshop})
                                .finally(() => {
                                    this.changeLabel()
                                    this.setBillSettings(true);
                                })
                    }
        })
        this.setPspList()
        this.setActivePspList()
        this.getCategoriesForSelect()
    },
}
</script>

<style>

</style>